import React, { useContext } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";

import { demoContext } from "../../../../shared/store/contexts";

import { InitiativesLayout } from "../../../organisms/Layouts";
import { H3, P } from "../../../atoms/Texts";
import { OutlineButton } from "../../../atoms/Buttons";
import notSearchedImg from "../../../../assets/images/Curly Arrow.svg";

import { InitiativeCard } from "../../../atoms/Cards";

const AllInitiatives = () => {
  const { id } = useParams();

  const { initiatives } = useContext(demoContext);

  return (
    <InitiativesLayout>
      <div className="pb-8 xl:w-11/12">
        {initiatives?.length > 0 ? (
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
            {initiatives?.map((item) => (
              <InitiativeCard key={item.id} initiative={item} />
            ))}
          </div>
        ) : (
          <>
            <div className="flex flex-col items-center flex-grow justify-center">
              <img src={notSearchedImg} alt="" className="" />
              <H3 color="#22202D" className="mt-6" data-testid="eligibility-text">
                You’re not part of any initiative yet
              </H3>
              <P fontSize="16px" color="#7D7B96" className="mt-3 mb-0 text-center">
                Search for the initiative to join or create an initiative
              </P>
            </div>
            <div className="text-center mt-4">
              <Link to={`/dashboard/organization/${id}/initiatives/add`}>
                <OutlineButton color="#442ED0">Initiative Request</OutlineButton>
              </Link>
            </div>
          </>
        )}
      </div>
    </InitiativesLayout>
  );
};

export default AllInitiatives;
